import React from 'react'
import { Link } from 'widgets-for-react'

type Props = {
  to: string
  children: React.ReactNode
  className?: string
  onClick?: () => void
  title?: string
}

/*
This is a link that will automatically determine if it needs to be an <a> <Link> or <NavLink>
 */
export const ExternalLink = (props: Props) => {
  const { to, ...rest } = props
  return /^https?:\/\//.test(to) ? (
    <a {...rest} href={to} target="_blank" rel="noopener noreferrer" />
  ) : /.pdf$/.test(to) ||
    /.docx?$/.test(to) ||
    /.pptx?$/.test(to) ||
    /.xlsx?$/.test(to) ? (
    <a {...rest} href={to} target="_blank" rel="noopener noreferrer" />
  ) : (
    <Link {...rest} to={to} />
  )
}
